import AgendaItemAttendee from "@/domain/entities/agenda/AgendaItemAttendee";
import AgendaItemResponseStatus from "@/domain/entities/agenda/AgendaItemResponseStatus";
import { AgendaItemAttendee as AgendaItemAttendeeSDK } from "@cs_teamwaydev/mailvista-sdk_react";

const agendaItemAttendeeToDomainMapper = (
    agendaItemAttendee: AgendaItemAttendeeSDK,
): AgendaItemAttendee =>
    new AgendaItemAttendee({
        emailAddress: agendaItemAttendee.emailAddress,
        status: agendaItemAttendee.status as AgendaItemResponseStatus,
    });

export default agendaItemAttendeeToDomainMapper;
